import client from '../httpClient';

const settingGroupStoreSearchHistoryApi = (params) => {
  return client.get('/store-groups/settings/history/search/', { params });
};

export default settingGroupStoreSearchHistoryApi;
